// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".min." + {"349":"ea70a139320ab17b1cb8","688":"b8c0e00a0c17933aea0d"}[chunkId] + ".js";
};